import React from 'react'

interface Props {
  level: number
  size?: number | string
  variant?: 'icon' | 'shape'
  className?: string
}

const levelIcons = [
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level1.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level2.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level3.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level4.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level5.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level6.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level7.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level8.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level9.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/Level10.svg'
]

const shapeLevelIcons = [
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel1.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel2.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel3.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel4.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel5.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel6.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel7.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel8.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel9.svg',
  'https://cdn.thingtesting.com/assets/thingtester/levels/ShapeLevel10.svg'
]

export const LevelIcon = ({ level, size = 16, variant = 'icon', className }: Props) => {
  if (level > levelIcons.length || level === 0) {
    return null
  }

  return (
    <img
      alt={`Level ${level}`}
      title={`Level ${level}`}
      width={size}
      height={size}
      className={className}
      src={variant === 'shape' ? shapeLevelIcons[level - 1] : levelIcons[level - 1]}
    />
  )
}
